import { NhisPrivacyTerm, NhisThirdPartyTerm } from '@components';
import React from 'react';
import { useParams } from 'react-router-dom';

const NhisTermTemplate = () => {
  const { type } = useParams();
  return (
    <>
      {type === 'privacy' && <NhisPrivacyTerm />}
      {type === 'thirdparty' && <NhisThirdPartyTerm />}
    </>
  );
};

export default NhisTermTemplate;
